/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name PayRules
 */
angular.module('mercury.modules.time.compliance.payrules')
.factory('PayRules', ["$resource", "settings", function($resource, settings) {
  var Packages = $resource(settings.mercHost + '/pay-rules/packages/:id');

  function getAll() {
    return Packages.query().$promise;
  }

  function getById(id) {
    return Packages.get({id: id}).$promise;
  }

  return {
    getAll: getAll,
    getById: getById
  };
}]);
